module.exports = __webpack_public_path__ + "static/media/friendsIcon.c0f89de2.png";